import { render } from "./explain.vue?vue&type=template&id=25d864cc&scoped=true"
import script from "./explain.vue?vue&type=script&lang=js"
export * from "./explain.vue?vue&type=script&lang=js"

import "./explain.vue?vue&type=style&index=0&id=25d864cc&scoped=true&lang=less"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d864cc"]])

export default __exports__